<mat-expansion-panel [togglePosition]="'before'">
    <mat-expansion-panel-header>
    <mat-panel-title>
        Employment and Wage Information
    </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="p-4">
    <!-- Employment Information --> 
    <form [formGroup]="employmentWageForm">
        <div formArrayName="employement">
            <div *ngFor="let employee of employement().controls; let empIndex=index">
                <div [formGroupName]="empIndex">
                    <div class="row">
                        <div class="col-md-8">
                            <h5 class="labelText">Employment Information - {{empIndex+1}}</h5>
                        </div>
                        <div class="col-md-2 text-right">
                            <mat-icon class="remove" *ngIf="empIndex !== 0" (click)="removeEmployement(empIndex)">delete</mat-icon>
                        </div>
                        <div class="col-md-2 d-flex justify-content-end" *ngIf="isDuplicateLCA">
                            <button class="clear-data-button" (click)="clearData()">
                                <i class="fa fa-repeat"></i> Clear Data
                             </button>
                        </div>
                    </div> 
                    <div class="row">
                        <!-- Estimated No. of Workers -->
                        <div class="col-md-12">
                            <label class="label-cls required">Enter the estimated number of workers that will perform work at this place of employment under the LCA</label>
                        </div>
                        <div class="form-group col-md-4">
                            <input class="im-input"
                                    autocomplete="off"
                                    name="noOfWorkers"
                                    formControlName="noOfWorkers"
                                    type="text"
                                    placeholder="Enter"/>
                            <span class="invalid-message"
                                  *ngIf="(employement().controls[empIndex].get('noOfWorkers').touched && employement().controls[empIndex].get('noOfWorkers').invalid) || (employement().controls[empIndex].get('noOfWorkers').touched && employement().controls[empIndex].get('noOfWorkers').errors?.required)">
                                  {{ getGlobalErrorMessages("INVALID_NUMBER") }}
                            </span>
                        </div> 
                    </div>
                    <div class="row">
                        <!-- Employer represented by an attorney or agent -->
                        <div class="form-group slider-toggle col-md-6">
                            <h6>Indicate whether the worker(s) subject to this LCA will be placed with a secondary entity at this place of employment
                            </h6>  
                        </div>
                        <div class="col-md-6 slider-toggle">
                            <mat-slide-toggle class="vertically-middle" 
                                              formControlName="isEmprReprAttorney"
                                              (change)="onChangeSecondaryEntity($event.checked, empIndex)">
                            </mat-slide-toggle>
                        </div>
                    </div>
                    <div class="row" *ngIf="employement().controls[empIndex].get('isEmprReprAttorney').value === true">
                        <!-- provide the legal business name of the secondary entity -->
                        <div class="col-md-12">
                            <label class="label-cls required">Provide the legal business name of the secondary entity</label>
                        </div>
                        <div class="form-group col-md-4">
                            <input class="im-input"
                                    autocomplete="off"
                                    type="text" 
                                    name="secEntBusName"
                                    formControlName="secEntBusName"
                                    placeholder="Enter"
                                    />
                            <span class="invalid-message"
                                *ngIf="(employement().controls[empIndex].get('secEntBusName').touched && 
                                employement().controls[empIndex].get('secEntBusName').errors?.minlength) || (employement().controls[empIndex].get('secEntBusName').value && employement().controls[empIndex].get('secEntBusName').errors?.minlength)">
                                {{ getGlobalErrorMessages("INVALID_NAME_5") }}
                            </span>
                        </div> 
                    </div>
                    <!-- Place of Employment -->
                    <div class="row">
                        <!-- Address 1 -->
                        <div class="form-group col-md-6">
                            <h6 class="sub-heading">Place of Employment</h6>
                            <label class="required label-cls">Address 1</label>
                            <input class="im-input"
                                    autocomplete="off"
                                    type="text"
                                    id="addressLine1"
                                    name="addressLine1"
                                    formControlName="addressLine1"
                                    placeholder="Enter" />
                            <mat-hint>Ex. : Street Name & Number</mat-hint>
                            <span class="invalid-message"
                                *ngIf="employement().controls[empIndex].get('addressLine1').touched && 
                                employement().controls[empIndex].get('addressLine1').errors?.required">
                                {{ getGlobalErrorMessages("REQUIRED") }}
                            </span>
                        </div>
                    </div> 
                    <div class="row">
                        <!-- Address 2 -->
                        <div class="form-group col-md-6">
                            <label class="label-cls">Address 2</label>
                            <input class="im-input"
                                    autocomplete="off"
                                    type="text" 
                                    name="addressLine2"
                                    formControlName="addressLine2"
                                    placeholder="Enter" />
                            <mat-hint>Ex. : Apartment., Suite, Building</mat-hint>
                        </div>
                    </div>
                    <div class="row"> 
                        <!-- county -->
                        <div class="form-group col-md-4">
                            <label class="label-cls required mb-1">State/District/Territory</label>
                            <p-dropdown class="w-100" appendTo="body"   name="stateCityTerritory" [options]="listStates" formControlName="state" placeholder="Select" optionLabel="stateProvinceName" optionValue="stateProvinceCode" (onChange)="onChangeState($event.value, empIndex)">
                            </p-dropdown>

                            <span class="invalid-message"
                                *ngIf="(employement().controls[empIndex].get('state').touched && employement().controls[empIndex].get('state').errors?.required)">
                                {{ getGlobalErrorMessages("REQUIRED") }}
                            </span>

                        </div>
                        <!-- State -->
                        <div class="form-group col-md-4">
                            <label class="label-cls required mb-1">County</label>
                            <p-dropdown class="w-100" appendTo="body"  name="county" [options]="listCounty0" formControlName="county" placeholder="Select" (onChange)="getWageLevels(empIndex, $event, employement().controls[empIndex].get('state').value)" *ngIf="empIndex===0">
                            </p-dropdown>
                            <p-dropdown class="w-100" appendTo="body"  name="county" [options]="listCounty1" formControlName="county" placeholder="Select" (onChange)="getWageLevels(empIndex, $event, employement().controls[empIndex].get('state').value)" *ngIf="empIndex===1">
                            </p-dropdown>
                            <p-dropdown class="w-100" appendTo="body"  name="county" [options]="listCounty2" formControlName="county" placeholder="Select" (onChange)="getWageLevels(empIndex, $event, employement().controls[empIndex].get('state').value)" *ngIf="empIndex===2">
                            </p-dropdown>

                            <span class="invalid-message"
                                *ngIf="(employement().controls[empIndex].get('county').touched && employement().controls[empIndex].get('county').errors?.required)">
                                {{ getGlobalErrorMessages("REQUIRED") }}
                           </span>
                           
                        </div>
                        <!-- City -->
                        <div class="form-group col-md-4">
                            <label class="required label-cls">City</label>
                            <input class="im-input"
                                    autocomplete="off"
                                    name="city"
                                    formControlName="city"
                                    type="text"
                                    placeholder="Enter"/>
                            <span class="invalid-message"
                                    *ngIf="employement().controls[empIndex].get('city').touched && employement().controls[empIndex].get('city').errors?.required">
                                    {{ getGlobalErrorMessages("REQUIRED") }}
                            </span>
                        </div> 
                    </div>
                    <div class="row">
                        <!-- ZIP / Postal Code -->
                        <div class="form-group col-md-4"> 
                            <label class="label-cls required">ZIP / Postal Code</label>
                            <input class="im-input"
                                    autocomplete="off"
                                    name="postalCode"
                                    formControlName="postalCode"
                                    type="text"
                                    placeholder="Enter"/>
                            <span class="invalid-message"
                                *ngIf="(employement().controls[empIndex].get('postalCode').touched && employement().controls[empIndex].get('postalCode').errors?.required)">
                                {{ getGlobalErrorMessages("REQUIRED") }}
                            </span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr class="dashed-border">
                        </div>
                    </div>

                    <!-- Wage Results -->
                    <div class="row mb-3">
                        <div *ngIf="wageResults && wageResults.length > 0 && wageResults[empIndex]" class="col-md-12">
                            <label class="control-lbl required mb-3 label-cls sub-heading">Wage Results</label>
                            <h6 class="mb-3"><b>Showing all Industries database for {{wageResults[empIndex].yearDuration}}</b></h6>
                            <p class="mb-2"><strong>GeoLevel:</strong> {{wageResults[empIndex].geoLevel}}</p>
                            <p class="mb-2"><strong>Level 1 Wage:</strong> {{wageResults[empIndex].level1}}</p>
                            <p class="mb-2"><strong>Level 2 Wage:</strong> {{wageResults[empIndex].level2}}</p>
                            <p class="mb-2"><strong>Level 3 Wage:</strong> {{wageResults[empIndex].level3}}</p>
                            <p class="mb-2"><strong>Level 4 Wage:</strong> {{wageResults[empIndex].level4}}</p>
                        </div>
                    </div>
                    <div class="row mb-3" *ngIf="wageResultsEducation && wageResultsEducation.length > 0 && wageResultsEducation[empIndex]">
                        <div class="col-md-12">
                            <label class="control-lbl required mb-3 label-cls sub-heading">Wage Results</label>
                            <h6 class="mb-3"><b>Showing ACWIA - Education Industry database for {{wageResultsEducation[empIndex].yearDuration}}</b></h6>
                            <p class="mb-2"><strong>GeoLevel:</strong> {{wageResultsEducation[empIndex].geoLevel}}</p>
                            <p class="mb-2"><strong>Level 1 Wage:</strong> {{wageResultsEducation[empIndex].level1}}</p>
                            <p class="mb-2"><strong>Level 2 Wage:</strong> {{wageResultsEducation[empIndex].level2}}</p>
                            <p class="mb-2"><strong>Level 3 Wage:</strong> {{wageResultsEducation[empIndex].level3}}</p>
                            <p class="mb-2"><strong>Level 4 Wage:</strong> {{wageResultsEducation[empIndex].level4}}</p>
                        </div>
                    </div>

                    <!-- Wage Details -->
                    <div class="row">
                        <!-- Address 1 -->
                        <div class="col-md-6">
                            <h6 class="sub-heading">Wage Details</h6>
                            <p>Wage paid to non-immigrant</p>
                        </div>
                    </div>
                    <div class="row">
                        <!-- From ($) -->
                        <div class="form-group col-md-2">
                            <label class="required label-cls">From ($)</label>
                            <input class="im-input"
                                    autocomplete="off"
                                    type="number" 
                                    name="wageRangeFrom"
                                    formControlName="wageRangeFrom"
                                    placeholder="Enter" />
                            <span class="invalid-message"
                                *ngIf="(employement().controls[empIndex].get('wageRangeFrom').touched && 
                                employement().controls[empIndex].get('wageRangeFrom').errors?.required) || (employement().controls[empIndex].get('prvlWageRate').value > employement().controls[empIndex].get('wageRangeFrom').value)">
                                {{ getGlobalErrorMessages("INVALID_PREVAILING_WAGE") }}
                            </span>
                        </div>
                        <!-- To ($) -->
                        <div class="form-group col-md-2">
                            <label class="label-cls">To ($)</label>
                            <input class="im-input"
                                    autocomplete="off"
                                    type="number" 
                                    name="wageRangeTo"
                                    formControlName="wageRangeTo"
                                    placeholder="Enter" />
                                <span class="invalid-message"
                                    *ngIf="(employement().controls[empIndex].get('wageRangeTo').touched && 
                                    employement().controls[empIndex].get('wageRangeTo').errors?.required) || (employement().controls[empIndex].get('wageRangeTo').touched && employement().controls[empIndex].get('wageRangeTo').invalid) || (employement().controls[empIndex].get('wageRangeTo').touched && (employement().controls[empIndex].get('wageRangeFrom').value > employement().controls[empIndex].get('wageRangeTo').value)) || (employement().controls[empIndex].get('wageRangeTo').touched && (employement().controls[empIndex].get('wageRangeFrom').value == employement().controls[empIndex].get('wageRangeTo').value))">
                                    {{ getGlobalErrorMessages("INVALID_WAGERANGE") }}
                                </span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-6">
                            <label class="required label-cls">Wage paid to non-immigrant - per</label>
                            <div class="row pt-2">
                                <mat-radio-group aria-label="Select an option"
                                                 formControlName="wageRangeTypeCode">
                                    <mat-radio-button [value]="'HOUR'">Hour </mat-radio-button>
                                    <mat-radio-button [value]="'WEEK'">Week </mat-radio-button>
                                    <mat-radio-button [value]="'BIWEEKLY'">Bi-Weekly </mat-radio-button>
                                    <mat-radio-button [value]="'MONTH'">Month </mat-radio-button>
                                    <mat-radio-button [value]="'YEAR'">Year </mat-radio-button>
                                </mat-radio-group>
                                <span class="invalid-message"
                                    *ngIf="employement().controls[empIndex].get('wageRangeTypeCode').touched && 
                                    employement().controls[empIndex].get('wageRangeTypeCode').errors?.required">
                                    {{ getGlobalErrorMessages("REQUIRED") }}
                                </span>
                            </div>
                        </div> 
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr class="dashed-border">
                        </div>
                    </div>

                    <!-- Prevailing wage paid – rate details -->
                    <div class="row">
                        <div class="col-md-7">
                            <h6 class="sub-heading">Prevailing wage paid – rate details</h6>
                        </div>
                    </div>
                    <div class="row">
                        <!-- Prevailing wage paid - rate -->
                        <div class="form-group col-md-3">
                            <label class="required label-cls">Prevailing wage paid - rate</label>
                            <input class="im-input"
                                    autocomplete="off"
                                    type="number"
                                    name="prvlWageRate"
                                    formControlName="prvlWageRate"
                                    placeholder="Enter" />
                            <span class="invalid-message"
                                *ngIf="(employement().controls[empIndex].get('prvlWageRate').touched && employement().controls[empIndex].get('prvlWageRate').errors?.required)">
                                {{ getGlobalErrorMessages("REQUIRED") }}
                            </span>
                        </div>
                        <!-- Wage paid to non-immigrant - per -->
                        <div class="fomrm-group col-md-7">
                            <label class="required label-cls">Wage paid to non-immigrant - per</label>
                            <div class="row pt-2">
                                <mat-radio-group aria-label="Select an option"
                                                 formControlName="prvWageTypeCode">
                                    <mat-radio-button [value]="'HOUR'">Hour </mat-radio-button>
                                    <mat-radio-button [value]="'WEEK'">Week </mat-radio-button>
                                    <mat-radio-button [value]="'BIWEEKLY'">Bi-Weekly </mat-radio-button>
                                    <mat-radio-button [value]="'MONTH'">Month </mat-radio-button>
                                    <mat-radio-button [value]="'YEAR'">Year </mat-radio-button>
                                </mat-radio-group>
                                <span class="invalid-message"
                                    *ngIf="(employement().controls[empIndex].get('prvWageTypeCode').touched && 
                                    employement().controls[empIndex].get('prvWageTypeCode').errors?.required) || (employement().controls[empIndex].get('wageRangeTypeCode').value !== employement().controls[empIndex].get('prvWageTypeCode').value
                                    )"> 
                                    {{ getGlobalErrorMessages("INVALID_WAGE_PREVAILING") }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr class="dashed-border">
                        </div>
                    </div>


                    <!-- Identify the source used for the Prevailing wage -->
                    <div class="row">
                        <div class="col-md-7">
                            <h6 class="sub-heading">Identify the source used for the Prevailing wage</h6>
                        </div>
                    </div> 
                    <div class="row" *ngIf="(employement().controls[empIndex].get('pwdIssuedByLabor').value === '' && employement().controls[empIndex].get('OESProgram').value === '' && employement().controls[empIndex].get('otherThanOES').value === '') || ((employement().controls[empIndex].get('pwdIssuedByLabor').value === true) && (employement().controls[empIndex].get('OESProgram').value === '' && employement().controls[empIndex].get('otherThanOES').value === ''))">
                        <!-- Prevailing wage paid - rate --> 
                        <div class="form-group col-md-3">
                            <mat-checkbox class="label-cls" formControlName="pwdIssuedByLabor"
                                        (change)="onChangePrevailingWage($event.checked, empIndex, 'pwd')">
                                A Prevailing Wage Determination (PWD) issued by the Department of Labor
                            </mat-checkbox>
                            <!-- PWD tracking number -->
                            <label class="label-cls required">PWD tracking number</label>
                            <input class="im-input"
                                    autocomplete="off"
                                    type="text"
                                    name="pwdTrackNumber"
                                    formControlName="pwdTrackNumber"
                                    placeholder="Enter" />
                            <span class="invalid-message"
                                *ngIf="(employement().controls[empIndex].get('pwdTrackNumber').touched && employement().controls[empIndex].get('pwdTrackNumber').invalid) || (employement().controls[empIndex].get('pwdTrackNumber').touched && employement().controls[empIndex].get('pwdTrackNumber').errors?.required)">
                                {{ getGlobalErrorMessages("INVALID_TRACK_NUMBER") }}
                            </span>
                        </div>
                    </div>
                    <div class="row" *ngIf="(employement().controls[empIndex].get('pwdIssuedByLabor').value === '' && employement().controls[empIndex].get('OESProgram').value === '' && employement().controls[empIndex].get('otherThanOES').value === '') || ((employement().controls[empIndex].get('OESProgram').value === true) && (employement().controls[empIndex].get('pwdIssuedByLabor').value === '' && employement().controls[empIndex].get('otherThanOES').value === ''))">
                        <!-- A PW obtained independently from the Occupational Employment Statistics (OES) Program -->
                        <div class="form-group col-md-12">
                            <mat-checkbox class="label-cls" formControlName="OESProgram"
                                         (change)="onChangePrevailingWage($event.checked, empIndex, 'oes')">
                                          A PW obtained independently from the Occupational Employment Statistics (OES) Program
                            </mat-checkbox>
                            <div class="row">
                                <!-- Prevailing wage level -->
                                <div class="fomrm-group col-md-4">
                                    <label class="label-cls required">Prevailing wage level</label>
                                    <div class="row pt-2">
                                        <mat-radio-group aria-label="Select an option"
                                                         formControlName="pwdOesSourceLevelId">
                                            <mat-radio-button [value]="'WAGELVL1'">I </mat-radio-button>
                                            <mat-radio-button [value]="'WAGELVL2'">II </mat-radio-button>
                                            <mat-radio-button [value]="'WAGELVL3'">III </mat-radio-button>
                                            <mat-radio-button [value]="'WAGELVL4'">IV </mat-radio-button>
                                            <mat-radio-button [value]="'NOTAPPLCBL'">N/A </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>
                                <!-- Source Year -->
                                <div class="form-group col-md-2">
                                    <mat-form-field> 
                                        <label class="label-cls required">Source Year</label>
                                        <mat-select name="pwdOesSourceYear"
                                                    formControlName="pwdOesSourceYear">
                                          <mat-option *ngFor="let item of stateYearList" [value]="item">
                                            {{item}}
                                          </mat-option> 
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="form-group col-md-4">
                                    <label class="label-cls required">Area</label>
                                    <p-dropdown class="w-100" appendTo="body"   name="countyAreaName" [options]="countyAreaList[empIndex]" formControlName="countyAreaName" placeholder="Select">
                                    </p-dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="(employement().controls[empIndex].get('pwdIssuedByLabor').value === '' && employement().controls[empIndex].get('OESProgram').value === '' && employement().controls[empIndex].get('otherThanOES').value === '') || ((employement().controls[empIndex].get('otherThanOES').value === true) && (employement().controls[empIndex].get('pwdIssuedByLabor').value === '' && employement().controls[empIndex].get('OESProgram').value === ''))">
                        <!-- A PW obtained using another legitimate source (other than OES) or an independent authoritative source -->
                        <div class="form-group col-md-7">
                            <mat-checkbox class="label-cls" formControlName="otherThanOES"
                                          (change)="onChangePrevailingWage($event.checked, empIndex, 'other')">
                                          A PW obtained using another legitimate source (other than OES) or an independent authoritative source
                            </mat-checkbox> 
                            <div class="row">
                                <!-- Source Type -->
                                <div class="fomrm-group col-md-8">
                                    <label class="label-cls required">Source Type</label>
                                    <div class="row pt-2">
                                        <mat-radio-group aria-label="Select an option"
                                                         formControlName="pwdOtherSourceId"
                                                         (change)="onChangeOesSourceType($event, empIndex)">
                                            <mat-radio-button [value]="'CBA'">CBA </mat-radio-button>
                                            <mat-radio-button [value]="'DBA'">DBA </mat-radio-button>
                                            <mat-radio-button [value]="'SCA'">SCA </mat-radio-button>
                                            <mat-radio-button [value]="'OTHER'">Other/PW Survey </mat-radio-button>
                                        </mat-radio-group>
                                    </div> 
                                </div>
                                <!-- Source Year -->
                                <div class="form-group col-md-4">
                                    <mat-form-field> 
                                        <label class="label-cls required">Source Year</label>
                                        <mat-select name="pwdOtherSourceYear"
                                                    formControlName="pwdOtherSourceYear">
                                          <mat-option *ngFor="let item of stateYearList" [value]="item">
                                            {{item}}
                                          </mat-option> 
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <!-- Survey producer or publisher -->
                            <div class="row" *ngIf="employement().controls[empIndex].get('pwdOtherSourceId').value === 'OTHER'">
                                <div class="col-md-12">
                                    <label class="label-cls required">If responded “Other/ PW Survey”, Enter the name of the survey producer or publisher</label>
                                    <input class="im-input"
                                            autocomplete="off"
                                            type="text"
                                            name="otherPwdSurveyName"
                                            formControlName="otherPwdSurveyName"
                                            placeholder="Enter" />
                                </div>
                            </div>
                            <!-- Name of the PW survey -->
                            <div class="row"  *ngIf="employement().controls[empIndex].get('pwdOtherSourceId').value === 'OTHER'">
                                <div class="col-md-12">
                                    <label class="label-cls required">If responded "Other/ PW Survey" , enter the title or name of the PW survey</label>
                                    <input class="im-input"
                                            autocomplete="off"
                                            type="text"
                                            name="otherPwdSurveyPublshr"
                                            formControlName="otherPwdSurveyPublshr"
                                            placeholder="Enter" />
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr class="dashed-border">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="row add-more-employee">
        <!-- Add Employement -->
        <div class="col-md-12">
            <a class="add-more" *ngIf="employmentWageForm.get('employement').value.length<placeOfEmploymentInfoMaxCount" 
            (click)="handlePlaceOfEmptInfoCount(1)">
                Add More Employment Details
            </a>
            <hr class="dashed-border" *ngIf="employmentWageForm.get('employement').value.length!=3">
        </div>
   </div>
</div>

<!-- Confirm Reset Modal -->
<p-confirmDialog id="confirm-reset-modal" [style]="{width: '35vw'}"></p-confirmDialog>

</mat-expansion-panel>


